import { useNavigate, useRouterState } from '@tanstack/react-router';
import { Box } from 'components/Box';
import Icon from 'components/Icon/Icon.component';
import ArrowDownWhite from 'images/icons/chevron-down-white.svg?react';
import ArrowUpWhite from 'images/icons/chevron-up-white.svg?react';
import UserIconComponent from 'images/icons/user.svg?react';
import React from 'react';
import { useSelector, useStore } from 'react-redux';
import { requestDataIfNecessary } from 'services/api/api.actions';
import { selectNavbarContent } from 'services/cmsContent/cmsContent.selectors';
import { makeSelectPostFavoritesApiConfig } from 'services/favorites/favorites.selectors';
import useGetTranslate from 'utils/hooks/useGetTranslate';
import { VariantComponentProps } from '../SignedInUserToolbar.type';
import {
  BalanceDisplay,
  BonusLink,
  CurrencyLabel,
  DropdownChevron,
  NotificationLabel,
  ToolbarButton,
  UserWallet,
  VerticalSeparator,
} from '../style/SignedInUserToolbar.style';

const CompactVariant: React.FC<VariantComponentProps> =
  function CompactVariant({
    formattedBalance,
    formattedBonus,
    onDropdownToggle,
    onPanelToggle,
    isPanelExpanded,
  }) {
    const navbarContent = useSelector(selectNavbarContent);
    const { location } = useRouterState();
    const navigate = useNavigate();
    const reduxStore = useStore();
    const t = useGetTranslate();
    const handleDropdownClick = () => {
      const newValue = !isPanelExpanded;
      onDropdownToggle?.(newValue);
      onPanelToggle?.(newValue);
    };

    const handleChangeLocationToDashboard = () => {
      if (location.pathname !== '/') {
        navigate({ to: '/' });
      }
    };

    React.useEffect(() => {
      const postFavoritesApiConfig = makeSelectPostFavoritesApiConfig()(
        reduxStore.getState(),
      );
      reduxStore.dispatch(requestDataIfNecessary(postFavoritesApiConfig));
    }, [reduxStore]);

    return (
      <>
        <Box
          display={'flex'}
          alignItems={'center'}
          height={'100%'}
          position="relative"
          zIndex={isPanelExpanded ? 1001 : 'auto'}
        >
          <UserWallet>
            <BalanceDisplay>
              <NotificationLabel textAlign="left">
                {navbarContent.labelMyBalance}
              </NotificationLabel>
              <CurrencyLabel>{formattedBalance || ' '}</CurrencyLabel>
            </BalanceDisplay>
            <VerticalSeparator />
            <BonusLink
              noReferrer={false}
              target="_self"
              href={navbarContent.linkMyBonus}
            >
              <NotificationLabel textAlign="left">
                {navbarContent.labelMyBonus}
              </NotificationLabel>
              <CurrencyLabel>{formattedBonus || ' '}</CurrencyLabel>
            </BonusLink>
            <DropdownChevron
              type="button"
              onClick={handleDropdownClick}
              title="Area Riservata"
            >
              <Icon
                svgIconComponent={
                  isPanelExpanded ? ArrowUpWhite : ArrowDownWhite
                }
              />
            </DropdownChevron>
          </UserWallet>
          <ToolbarButton
            type="button"
            padding="0 0 0 0"
            onClick={handleChangeLocationToDashboard}
            title={t('reservedArea').toString()}
          >
            <Icon svgIconComponent={UserIconComponent} display="block" />
          </ToolbarButton>
        </Box>
      </>
    );
  };

export default CompactVariant;
